import { render } from "./App.vue?vue&type=template&id=f52aa3aa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f52aa3aa&lang=css"
script.render = render

export default script